import { Link } from 'react-scroll';
import { memo, useState } from 'react';

import Stack from '@mui/material/Stack';

import NavList from './nav-list';
import { useNavScroll } from '../hooks/useNavScroll';

import type { NavProps, NavGroupProps } from '../types';

// ----------------------------------------------------------------------

function NavSectionMini({ data, slotProps, ...other }: NavProps) {
  const [activeSection, setActiveSection] = useState(window.location.hash.slice(1));

  return (
    <Stack component="nav" id="nav-section-mini" spacing={`${slotProps?.gap || 4}px`} {...other}>
      {data.map((group, index) => (
        <Group
          key={group.subheader || index}
          items={group.items}
          slotProps={{ ...slotProps, activeSection }}
          onSetActive={setActiveSection}
        />
      ))}
    </Stack>
  );
}

export default memo(NavSectionMini);
// ----------------------------------------------------------------------

function Group({
  items,
  slotProps,
  onSetActive,
}: NavGroupProps & { onSetActive: (id: string) => void }) {
  const { disableSpy, handleClick, handleSetActive } = useNavScroll(onSetActive);

  return (
    <>
      {items.map((list) =>
        slotProps?.scrollNav ? (
          <Link
            key={list.title}
            to={list.path}
            data-testid={`nav-${list.path}`}
            spy={!disableSpy}
            offset={-80}
            smooth
            duration={550}
            onClick={() => handleClick(list.path)}
            onSetActive={() => handleSetActive(list.path)}
          >
            <NavList data={list} depth={1} slotProps={slotProps} />
          </Link>
        ) : (
          <NavList key={list.title} data={list} depth={1} slotProps={slotProps} />
        )
      )}
    </>
  );
}
